









import {
  Component, Prop, Vue,
} from 'vue-property-decorator'
import {Item} from './MenuItem.type'


@Component({
  components: {
    MenuItem: () => (import(/* webpackMode: "eager" */ './MenuItem.vue')),
  },
})
export default class MenuList extends Vue {
  @Prop() list: Item[]
}
